import React from 'react'
import { getMedPopName } from '../utils'
import { DEMOS_BY_COI } from '../../../../constants/map'
import { theme } from '../theme'
import GenericStack from '../GenericStack'

const PopStack = ({ pop }) => {
  const sortedPops = DEMOS_BY_COI.map(demo => ({
    id: demo,
    displayCount: Number(pop[demo]) || 0,
    color: theme.extras.demos[demo],
    name: getMedPopName(demo),
  })).sort((a, b) => b.displayCount - a.displayCount)

  // once sorted, assign ratios compared to largest demo pop
  sortedPops.forEach(demo => {
    demo.ratio =
      demo.displayCount / sortedPops[0].displayCount || 0.01 // if 0, show tiny nub
  })

  return <GenericStack items={sortedPops} />
}

export default PopStack
